import * as consts from './consts'

/**
 */
export const actionName = (name) => `${consts.ACTION_PREFIX}${name}`

/**
 */
export const info = require('debug')('module:plan:info')
